module.exports = __webpack_public_path__ + "static/media/Photo9.fd9cb741.jpg";